<template>
  <div class="bear-content" :class="'bear'+bearType+'-content'">
    <bear1 class="bear-img bear-img-1" v-if="bearType === 1"/>
    <bear2 class="bear-img bear-img-2" v-if="bearType === 2" :bear-position="bear"/>
    <bear3 class="bear-img bear-img-3" v-if="bearType === 3"/>
    <bear4 class="bear-img bear-img-4" v-if="bearType === 4"/>
    <bear5 class="bear-img bear-img-1" v-if="bearType === 5"/>
    <bear6 class="bear-img" :class="`bear-img-${bear}`" v-if="bearType === 6" :bear-position="bear"/>
    <bear7 class="bear-img bear-img-3" v-if="bearType === 7"/>
    <img :src="require(`@/assets/images/bears/paw${paw}.svg`)" class="paw" :class="`paw${position}`">
    <div class="bear-name" :class="`name${position}`">
      <div>
        <name-container
          :text="name"
          :chars-limit-one="10"
          :chars-limit-two="13"
          :chars-limit-three="16"
          size-one="0.9em"
          size-two="0.75em"
          size-three="0.6em" ></name-container>
      </div>
    </div>
  </div>
</template>

<script>
import Bear1 from './Bear1.vue'
import Bear2 from './Bear2.vue'
import Bear3 from './Bear3.vue'
import Bear4 from './Bear4.vue'
import Bear5 from './Bear5.vue'
import Bear6 from './Bear6.vue'
import Bear7 from './Bear7.vue'
import NameContainer from '@/components/NameContainer.vue'

export default {
  name: 'BearDonor',
  components: { Bear1, Bear2, Bear3, Bear4, Bear5, Bear6, Bear7, NameContainer },
  props: {
    name: {
      type: String,
      default: () => ''
    },
    bear: {
      type: Number
    },
    paw: {
      type: String
    },
    position: {
      type: Number
    }
  },
  computed: {
    bearType () {
      if (this.bear === 1) {
        return this.paw === 'generic' ? 1 : 5
      }
      if (this.bear === 2) {
        return this.paw === 'generic' ? 6 : this.bear
      }
      if (this.bear === 3) {
        return this.paw === 'generic' ? 7 : 3
      }
      if (this.bear === 4) {
        return this.paw === 'generic' ? 6 : this.bear
      }
    }
  }
}
</script>

<style>
  .bear-content {
    position: relative;
  }

  .bear-img-1 {
    height: 53vh;
  }

  .bear-img-2 {
    height: 60vh;
  }

  .bear-img-3 {
    height: 52vh;
  }

  .bear-img-4 {
    height: 58vh;
  }

  .bear-name {
    color: #59BEC9;
    font-size: 2.6vh;
    text-align: center;
    line-height: 1.3;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;
    position: absolute;
  }

  .bear1-content .bear-name {
    top: 42%;
    left: 24%;
    width: 29%;
    height: 28%;
    transform: rotate(-11deg);
  }

  .bear2-content .bear-name {
    top: 36%;
    left: 32%;
    width: 45%;
    height: 28%;
  }

  .bear3-content .bear-name {
    top: 41%;
    left: 41%;
    width: 34%;
    height: 24%;
    transform: rotate(6deg);
  }

  .bear4-content .bear-name {
    top: 36%;
    left: 31%;
    width: 44%;
    height: 25%;
  }

  .bear5-content .name1 {
    top: 38%;
    left: 25%;
    width: 31%;
    height: 28%;
    transform: rotate(-11deg);
  }

  .bear6-content .bear-name {
    top: 36%;
    left: 37%;
    width: 33%;
    height: 28%;
  }

  .bear7-content .bear-name {
    top: 39%;
    left: 43%;
    width: 32%;
    height: 25%;
    transform: rotate(6deg);
  }

  .paw1 {
    position: absolute;
    top: 51.5%;
    right: 34.5%;
    width: 8.7%;
    transform: rotate(138deg);
  }

  .paw2 {
    position: absolute;
    top: 14%;
    left: 6%;
    width: 13%;
  }

  .paw3 {
    position: absolute;
    top: 19%;
    left: 15%;
    width: 11.5%;
    transform: rotate(-10deg);
  }

  .paw4 {
    position: absolute;
    top: 14.7%;
    left: 5%;
    width: 13%;
  }

  .bear7-content .paw, .bear6-content .paw {
    display: none;
  }

  .bear5-content .paw1 {
    position: absolute;
    top: 16%;
    right: 23%;
    width: 11%;
    transform: none;
  }

</style>



// WEBPACK FOOTER //
// src/components/DonorSlide/BearDonor.vue